import { ICellRendererParams } from 'ag-grid-community';
import { TokenBalance } from '../../types';
import { numberWithCommas } from 'src/utils/number';

export const TransactionCountCellRenderer = (
  params: ICellRendererParams<TokenBalance>,
) => {
  const count = params.value as number;

  if (count === null || count === undefined) {
    return <span className="text-muted-foreground">-</span>;
  }

  const formattedCount = numberWithCommas(count);

  return <span className="font-mono text-foreground">{formattedCount}</span>;
};
